import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Constants } from '../Constants';

@Injectable()
export class TimeProvider {

    constructor(private http: HttpClient) {}

    public getEvents(obj: any = null): Promise<TimeEvent[]> {

        let eventUrl = Constants.protocol + Constants.eventServer +  "/event/fetch";

        if (obj) {
            // console.log('fetching ', obj);
            //console.trace();

            let params = new HttpParams();
            for(let p of Object.keys(obj)) {
                //console.log(p + ' is now ' + obj[p], obj);
                if (obj[p] || obj[p] === 0) {
                    if (obj[p] === Object(obj[p])) {
                        params = params.append(p, JSON.stringify(obj[p]));
                    } else {
                        params = params.append(p, obj[p]);
                    }
                }
            }

            eventUrl = eventUrl + '?' + params;
        }

        return this.http.get(eventUrl, Constants.httpOptions)
            .toPromise()
            .then(data => {
                let result: TimeEvent[] = [];
                
                if (Array.isArray(data)) {
                    for(let item of data) {
                        result.push( new TimeEvent().read(item) );
                    }
                }
                return result;
            })
            .catch(err => {
                console.log(err);
                return null; 
            });
    }

    public getEventsDetailed(obj: any): Promise<TimeEvent[]> {

        let eventUrl = Constants.protocol + Constants.eventServer +  "/event/fetch";

        if (obj) {
            // console.log('fetching detailed', obj);

            let params = new HttpParams();
            params = params.append('detailed', '1');
            for(let p of Object.keys(obj)) {
                //console.log(p + ' is now ' + obj[p], obj);
                if (obj[p] || obj[p] === 0) {
                    if (obj[p] === Object(obj[p])) {
                        params = params.append(p, JSON.stringify(obj[p]));
                    } else {
                        params = params.append(p, obj[p]);
                    }
                }
            }

            eventUrl = eventUrl + '?' + params;
        }

        return this.http.get(eventUrl, Constants.httpOptions)
            .toPromise()
            .then((data: any) => {

                let result: TimeEvent[] = [];
                
                if (Array.isArray(data)) {
                    for(let item of data) {
                        result.push( new TimeEvent().read(item) );
                    }
                }
                return result;
            })
            .catch(err => {
                console.log(err);
                return null; 
            });
    }

    public saveEvent(event: TimeEvent): Promise<any> {

        // console.log('Saving ', event);
        let saveUrl = Constants.protocol + Constants.eventServer +  "/event/save";

        return this.http.post(saveUrl, event, Constants.httpOptions)
        .toPromise()
        .then((result: any) => {
            if (result && result.id) {
                event.id = result.id;
                return event;
            }
            return event;
        })
    }

    public getTagsets(): Promise<any[]> {
        
        let tagsetUrl = Constants.protocol + Constants.eventServer +  "/tag/fetch";

        return this.http.get(tagsetUrl, Constants.httpOptions)
        .toPromise()
        .then(data => {
            if (data && Array.isArray(data)) {
                return data;
            }
            return [];
        })
        .catch((err) => {
            console.log(err);
            return [];
         });
    }

    public static readDate(src: any) {
        let utc = (src === '' + src) && src.includes('Z');
        let date = new Date(src);
        if (utc) {
            date = new Date(date.getTime() + (date.getTimezoneOffset() * 60 * 1000));
        }
        return date;
    }
}

export class TimeEvent {
    starts: Date;
    ends: Date;

    name: string;
    body: any;
    active: boolean = true;
    planned: boolean = true;
    allday: boolean = true;

    id: number;
    parent_id: number;
    root_id: number;
    left: number;
    right: number;

    tags: any = {};       // {tag: string, tagset: string}[] = [];
    resources: any = {};      //{res: string, relation: string}[] = [];

    public read(json: any): TimeEvent {

        if (json) {
            if (json.starts) {
                this.starts = TimeProvider.readDate(json.starts);
            } else this.starts = null;

            if (json.ends) {
                this.ends = TimeProvider.readDate(json.ends);

            } else this.ends = null;

            if (json.id)
                this.id = +json.id;
            if (json.parent_id)
                this.parent_id = +json.parent_id;
            if (json.root_id)
                this.root_id = +json.root_id;
            if (json.left)
                this.left = +json.left;
            if (json.right)
                this.right = +json.right;

            this.active = json.active && true;
            this.planned = !!json.planned;
            this.allday = !!json.allday;

            this.name = '' + json.name;
            this.body = json.body;

            if (json.tags instanceof String) {
                this.tags = JSON.parse(json.tags);
            } else {
                this.tags = (json.tags)? JSON.parse(JSON.stringify(json.tags)) : {};
            }
            if (json.resources instanceof String) {
                this.resources = JSON.parse(json.resources);
            } else {
                this.resources = (json.resources)? JSON.parse(JSON.stringify(json.resources)) : {};
            }
            // console.log(this);
        }
        return this;
    }
}